import { Component, Input, OnInit } from '@angular/core';
import { ISurveyAnswer } from '@maplix/utils';

@Component({
  selector: 'maplix-popup-fieldtype-select',
  templateUrl: './popup-fieldtype-select.component.html',
  styleUrls: ['./popup-fieldtype-select.component.scss']
})
export class PopupFieldtypeSelectComponent implements OnInit {
  @Input()
  public answer: ISurveyAnswer;

  constructor() { }

  ngOnInit(): void {
  }

}
